import { render, staticRenderFns } from "./iconNoteCredit.vue?vue&type=template&id=16af60a2&scoped=true"
import script from "./iconNoteCredit.vue?vue&type=script&lang=js"
export * from "./iconNoteCredit.vue?vue&type=script&lang=js"
import style0 from "./iconNoteCredit.vue?vue&type=style&index=0&id=16af60a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16af60a2",
  null
  
)

export default component.exports